import {
  SET_AUTO_VERSIONING_VERSION,
  SET_AUTO_VERSIONING_VERSION_SUCCESS,
  SET_AUTO_VERSIONING_VERSION_FAILURE,
  SET_AUTO_VERSIONING_BRANDS,
  SET_AUTO_VERSIONING_BRANDS_SUCCESS,
  SET_AUTO_VERSIONING_BRANDS_FAILURE,
  AUTO_VERSIONING_UNCONFIRM,
  AUTO_VERSIONING_UNCONFIRM_SUCCESS,
  AUTO_VERSIONING_UNCONFIRM_FAILURE,
  AUTO_VERSIONING_KICKOFF,
  AUTO_VERSIONING_KICKOFF_SUCCESS,
  AUTO_VERSIONING_KICKOFF_FAILURE,
  FETCH_AUTO_VERSIONING_PROGRESS,
  FETCH_AUTO_VERSIONING_PROGRESS_SUCCESS,
  FETCH_AUTO_VERSIONING_PROGRESS_FAILURE,
  AUTO_VERSIONING_RESET,
  AUTO_VERSIONING_RESET_SUCCESS,
  AUTO_VERSIONING_RESET_FAILURE,
  AUTO_VERSIONING_CANCEL,
  AUTO_VERSIONING_CANCEL_SUCCESS,
  AUTO_VERSIONING_CANCEL_FAILURE,
  AUTO_VERSIONING_ROLLBACK,
  AUTO_VERSIONING_ROLLBACK_SUCCESS,
  AUTO_VERSIONING_ROLLBACK_FAILURE,
} from './types'

export const setVersion = (indexVersion, accessToken) => ({ type: SET_AUTO_VERSIONING_VERSION, payload: { indexVersion, accessToken } })
export const setVersionSuccess = () => ({ type: SET_AUTO_VERSIONING_VERSION_SUCCESS })
export const setVersionFailure = (error) => ({ type: SET_AUTO_VERSIONING_VERSION_FAILURE, payload: error })

export const setBrands = (brandsToIndex, accessToken) => ({ type: SET_AUTO_VERSIONING_BRANDS, payload: { brandsToIndex, accessToken } })
export const setBrandsSuccess = () => ({ type: SET_AUTO_VERSIONING_BRANDS_SUCCESS })
export const setBrandsFailure = (error) => ({ type: SET_AUTO_VERSIONING_BRANDS_FAILURE, payload: error })

export const unconfirm = (accessToken) => ({ type: AUTO_VERSIONING_UNCONFIRM, payload: { accessToken } })
export const unconfirmSuccess = () => ({ type: AUTO_VERSIONING_UNCONFIRM_SUCCESS })
export const unconfirmFailure = (error) => ({ type: AUTO_VERSIONING_UNCONFIRM_FAILURE, payload: error })

export const kickoff = (accessToken) => ({ type: AUTO_VERSIONING_KICKOFF, payload: { accessToken } })
export const kickoffSuccess = () => ({ type: AUTO_VERSIONING_KICKOFF_SUCCESS })
export const kickoffFailure = (error) => ({ type: AUTO_VERSIONING_KICKOFF_FAILURE, payload: error })

export const fetchProgress = (accessToken) => ({ type: FETCH_AUTO_VERSIONING_PROGRESS, payload: { accessToken } })
export const fetchProgressSuccess = (progress) => ({ type: FETCH_AUTO_VERSIONING_PROGRESS_SUCCESS, payload: progress })
export const fetchProgressFailure = (error) => ({ type: FETCH_AUTO_VERSIONING_PROGRESS_FAILURE, payload: error })

export const rollback = (accessToken) => ({ type: AUTO_VERSIONING_ROLLBACK, payload: { accessToken } })
export const rollbackSuccess = () => ({ type: AUTO_VERSIONING_ROLLBACK_SUCCESS })
export const rollbackFailure = (error) => ({ type: AUTO_VERSIONING_ROLLBACK_FAILURE, payload: error })

export const cancel = (accessToken) => ({ type: AUTO_VERSIONING_CANCEL, payload: { accessToken } })
export const cancelSuccess = () => ({ type: AUTO_VERSIONING_CANCEL_SUCCESS })
export const cancelFailure = (error) => ({ type: AUTO_VERSIONING_CANCEL_FAILURE, payload: error })

export const reset = (accessToken) => ({ type: AUTO_VERSIONING_RESET, payload: { accessToken } })
export const resetSuccess = () => ({ type: AUTO_VERSIONING_RESET_SUCCESS })
export const resetFailure = (error) => ({ type: AUTO_VERSIONING_RESET_FAILURE, payload: error })
